export const USER_ROLES = ['person', 'charity', 'admin'];
export const CHARITY_STATUSES = ['pending', 'approved', 'rejected', 'suspended'];
export const ITEM_STATUSES = [
    'draft',
    'active',
    'reserved',
    'given',
    'expired',
    'removed',
];
export const AI_STATUSES = ['pending', 'done', 'failed', 'flagged'];
export const ITEM_CATEGORIES = [
    'furniture',
    'clothing',
    'kids',
    'electronics',
    'kitchen',
    'books',
    'sports',
    'tools',
    'toys',
    'bedding',
    'appliances',
    'baby',
    'medical-aids',
    'garden',
    'office',
    'art',
    'music-instruments',
    'pet-supplies',
    'crafts',
    'jewelry',
    'shoes',
    'bags',
    'food-non-perishable',
    'beauty',
    'other',
];
export const ITEM_CONDITIONS = ['new', 'like-new', 'good', 'fair', 'broken'];
export const NOTIFICATION_TYPES = [
    'wishlist_match',
    'new_interest',
    'selected_as_recipient',
    'not_selected',
    'new_message',
    'charity_approved',
    'charity_rejected',
    'item_expired',
    'item_removed',
];
//# sourceMappingURL=index.js.map